import { render, staticRenderFns } from "./EbookCard.vue?vue&type=template&id=77a80916&scoped=true&"
import script from "./EbookCard.vue?vue&type=script&lang=js&"
export * from "./EbookCard.vue?vue&type=script&lang=js&"
import style0 from "./EbookCard.vue?vue&type=style&index=0&id=77a80916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a80916",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
